// src/routes/AppRoutes.jsx
import { Routes, Route } from "react-router-dom";
import MainLayout from "../components/layout/MainLayout";
import Home from "../pages/home/Home";
import PhotoBook from "../pages/photobook/photobook";
import Dailyplanner from "../pages/dailyplanner";
import ProductPage from "../pages/Products";
import Productivityplanner from "../pages/productivityplanner";
import TravelPlanner from "../pages/travelplanner";
import BridalPlanner from "../pages/BridalPlanner";
import Weeklydeskplanner from "../pages/Weeklydeskplanner";
import Listnotepads from "../pages/Listnotepads";
import Twplanners from "../pages/Twplanners";
import Wellnessjournals from "../pages/Wellnessjournals";
import Bulletjournals from "../pages/Bulletjournals";
import Gratitudejournals from "../pages/Gratitudejournals";
import PhotobookProductPage from "../pages/photobook/Photobookproductpage";
import PhotobookEditor from "../pages/photobook/Photobookeditor";
import CheckoutPage from "../pages/CheckoutPage";
import RecipeJournals from "../pages/RecipeJournals";
import Notebooks from "../pages/notebook/Notebooks";
import BoldBright from "../pages/notebook/BoldBright";
import ChecksStripes from "../pages/notebook/ChecksStripes";
import Florals from "../pages/notebook/Florals";
import PatternsPrints from "../pages/notebook/PatternsPrints";
import Gifthamper from "../pages/Gifthamper/gifthamper";
import PhotobookCart from "../pages/photobook/Photobookcart";
import CartPage from "../pages/CartPage";
import Privacypolicy from "../pages/privacypolicy";
import Termsofservice from "../pages/termsofservice";
import Refundpolicy from "../pages/refundpolicy";
import AdminDashboard from "../../src/admin/pages/AdminDashboard";
import OrderSuccess from "../pages/OrderSuccess";
import PhotobookOrdersAdmin from "../admin/pages/PhotobookOrdersAdmin";
import Hamper from "../pages/Hamper";


const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Home />} />
        <Route path="Dailyplanner" element={<Dailyplanner />} />
        <Route path="dailyplanners/:slug" element={<ProductPage />} />
        <Route path="Productivityplanner" element={<Productivityplanner />} />
        <Route path="productivityplanner/:slug" element={<ProductPage />} />
        <Route path="travel-planner" element={<TravelPlanner />} />
        <Route path="travel-planner/:slug" element={<ProductPage />} />
        <Route path="bridal-planner" element={<BridalPlanner />} />
        <Route path="bridal-planner/:slug" element={<ProductPage />} />
        <Route path="weekly-desk-planner" element={<Weeklydeskplanner />} />
       <Route path="weekly-desk-planner/:slug" element={<ProductPage />} />
        <Route path="list-notepads" element={<Listnotepads />} />
        <Route path="list-notepads/:slug" element={<ProductPage />} />
        <Route path="twplanner" element={<Twplanners />} />
        <Route path="twplanner/:slug" element={<ProductPage />} />
        <Route path="gratitude-journals" element={<Gratitudejournals />} />
        <Route path="gratitude-journals/:slug" element={<ProductPage />} />
        <Route path="wellness-journals" element={<Wellnessjournals />} />
        <Route path="wellness-journals/:slug" element={<ProductPage />} />
        <Route path="bullet-journals" element={<Bulletjournals />} />
        <Route path="bullet-journals/:slug" element={<ProductPage />} />
        <Route path="photobook" element={<PhotoBook />} />
        <Route path="photobook/:slug" element={<PhotobookProductPage />} />
        <Route path="recipe-journals" element={<RecipeJournals />} />
        <Route path="recipe-journals/:slug" element={<ProductPage />} />
        <Route path="notebooks" element={<Notebooks />} />
        <Route path="notebooks/:slug" element={<ProductPage />} />
        <Route path="/bold-bright" element={<BoldBright />} />
        <Route path="/bold-bright/:slug" element={<ProductPage />} />
        <Route path="/checks-stripes" element={<ChecksStripes />} />
        <Route path="/checks-stripes/:slug" element={<ProductPage />} />
        <Route path="/florals-in-notebooks" element={<Florals />} />
        <Route path="/florals/:slug" element={<ProductPage />} />
        <Route path="/patterns-prints" element={<PatternsPrints />} />
        <Route path="/patterns-prints/:slug" element={<ProductPage />} />
        <Route path="/gift-hampers" element={<Gifthamper />} />
        <Route path="/gift-hampers/:slug" element={<ProductPage />} />
        <Route path="/photobook-cart" element={<PhotobookCart />} />
        <Route path="/cartPage" element={<CartPage />} />
        <Route path="/cartPage/:slug" element={<ProductPage />} />
        <Route path="/privacy-policy" element={<Privacypolicy />} />
        <Route path="/terms-of-service" element={<Termsofservice/>} />
        <Route path="/refund-policy" element={<Refundpolicy/>} />
        <Route path="/fatherday/:slug" element={<ProductPage />} />
        <Route path="homenotebook/:slug" element={<ProductPage />} />
        <Route path="collection-products/:slug" element={<ProductPage />} />
        <Route path= "/order-successs" element={<OrderSuccess />} />
        <Route path="/admin/photobook-orders" element={<PhotobookOrdersAdmin />} />
        <Route path="/hamper" element={<Hamper />} />
       
        
      </Route>

      {/* MainLayout ke bahar — full screen pages */}
       <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/photobook/:slug/editor" element={<PhotobookEditor />} />
    </Routes>
  );
};

export default AppRoutes;